const videoBtns = document.querySelectorAll('.video__play-button');
const isMobile = window.matchMedia('(max-width: 768px)').matches;

if (videoBtns) {
    videoBtns.forEach(el => {
        el.addEventListener('click', () => {
            const template = el.parentElement.querySelector('.js-video-template');
            appendIFrame(template);
        });
        
        el.addEventListener('keydown', e => {
            if (e.code === 'Enter') {
                const template = el.parentElement.querySelector('.js-video-template');
                appendIFrame(template);
            }
        });
    });
}

export function appendIFrame(template, src) {
    if (!template) {
        return;
    }

    const parent = template.parentNode;

    if (!parent) {
        return;
    }

    if (parent.querySelector('.video__container')) {
        parent.querySelectorAll('.video__container').forEach(el => {
            el.remove();
        });
    }

    const clone = template.content.cloneNode(true);

    const btnPlay = parent.querySelector('.video__play-button');
    if (btnPlay) {
        if (!isMobile) {
            btnPlay.remove();
        } else {
            btnPlay.classList.add('video__play-button--hidden');
        }
    }

    const image = parent.querySelector('.img-fluid');

    if (image) {
        if (!isMobile) {
            image.remove();
        } else {
            image.classList.add('img--hidden');
        }
    }

    const iframe = clone.querySelector('.video__container');
    if (src !== undefined) {
        iframe.children[0].setAttribute("src", src);
    }

    if (iframe) {
        parent.appendChild(iframe);
    }    
}
